var _style, _desc, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWelcomeToMorrisons(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 89 89",
    style: {
      enableBackground: "new 0 0 89 89"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FCBC00;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Clip-2_1_"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M8.5,64.6v4.9c7.6-0.4,24.7-2.3,37.6-11.9l-5.5-2.2C29.2,62.5,15.2,64.2,8.5,64.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M46.1,57.6c4.8,1.7,9.6,2.9,14.9,3.6c5.3,0.7,11,0.8,17.6,0.3c1.4-0.1,1.9-1.8,1.9-2.4c0-0.6-0.5-2.2-2.1-2.2 c-13.4,0.4-19.1-0.4-28-3.1c4.3-4.2,7.8-9.5,9.9-16.2c2.3-7.6,1-13.7-3.7-16.7c-2.6-1.6-5.3-2-8-1c-3.3,1.2-5.8,4-7.5,7 c-2.9-2.6-8.2-5.9-13.8-2.5c-2.3,1.4-3.8,4.1-4.2,7.5c-0.6,5.4,1.7,11.4,5.9,15.7c2.8,2.8,6.8,5.5,11.6,7.8 M45.2,52.1 c-5.3-2.1-9.8-4.8-13.1-8.1c-3.8-3.8-4.8-8.6-4.5-11.5c0.2-1.8,0.9-3.2,1.9-3.8c0.6-0.4,1.2-0.6,1.8-0.7c4.3-0.7,8.5,4.5,8.5,4.6 c0.5,0.7,1.3,1,2.1,0.9h0c0.8-0.1,1.5-0.7,1.8-1.5c1.1-2.9,3.5-6.3,6.2-7.3c1.4-0.5,2.8-0.3,4.2,0.6c3.8,2.5,2.5,8.5,1.7,10.9 C53.8,43,49.9,48.2,45.2,52.1z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomeToMorrisons);
export default __webpack_public_path__ + "static/media/welcome-to-morrisons.d6a323442fec30f976806ce7d61af244.svg";
export { ForwardRef as ReactComponent };